import api from '@/services/api'
const url = action => `/users${action}`

export async function postFindByCondition(page, params){
    const { data: res } = await api.post(url('/findByCondition?page=' + page),params)
    return res
}

export async function postCreateUser(params){
    const { data: res } = await api.post(url('/'),params)
    return res
}

export async function putUserById(id, params){
    const { data: res } = await api.put(url('/' + id),params)
    return res
}

export async function deleteUserById(id){
    const { data: res } = await api.delete(url('/' + id))
    return res
}